import { useStorageAdapter as e } from "./storage/StorageAdapterContext.mjs";
import { useCallback as t, useState as n } from "react";
//#region src/useLocalStorage.ts
function r(r, i) {
	let a = e(), [o, s] = n(() => {
		try {
			let e = a.getItem(r);
			return e === null ? i : JSON.parse(e);
		} catch {
			return i;
		}
	});
	return [o, t((e) => {
		try {
			a.setItem(r, JSON.stringify(e)), s(e);
		} catch {}
	}, [r, a])];
}
//#endregion
export { r as useLocalStorage };
